import { Container, styled } from "@mui/material";

const ABOUT_TABS_PREFIX = "AboutTabs";

export const aboutTabsClasses = {
  root: `${ABOUT_TABS_PREFIX}-root`,
};

export const StyledAboutTabs = styled(Container)(({ theme }) => ({}));
